import React from 'react';

import Layout from '../../components/Layout';
import accessImg from './images/access-image@3x.jpg';
import './styles.scss';

const TrialUpgradeThanks = () => (
  <Layout useMemorized={false}>
    <section className="trial-upgrade-thanks">
      <div className="trial-upgrade-thanks__text">
        <h2>
          Yay, You&apos;re a
          <br />
          FabFitFun Member!
        </h2>
        <p>
          You’re all set to enjoy the perks of being a FabFitFun member.
          You will receive an email confirming your subscription.
        </p>
        <a className="trial-upgrade-thanks__link fff-btn-primary desktop" href="/">GO TO HOMEPAGE</a>
      </div>
      <div className="trial-upgrade-thanks__image">
        <img src={accessImg} alt="access" />
      </div>
      <a className="trial-upgrade-thanks__link fff-btn-primary mobile" href="/">GO TO HOMEPAGE</a>
    </section>
  </Layout>
);

export default TrialUpgradeThanks;
